import { render, staticRenderFns } from "./DirectiveActivityEditor.vue?vue&type=template&id=68f9b8d3"
import script from "./DirectiveActivityEditor.vue?vue&type=script&lang=js"
export * from "./DirectiveActivityEditor.vue?vue&type=script&lang=js"
import style0 from "./DirectiveActivityEditor.vue?vue&type=style&index=0&id=68f9b8d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports